import { CombinedGraphQLErrors } from "@apollo/client/errors";
import { useCallback } from "react";
import { useAppToast } from "@/components/AppToast";

export function isOpDataNotPopulatedError(error: unknown): boolean {
  if (!CombinedGraphQLErrors.is(error)) return false;
  return error.errors.some(
    (e) => e.extensions?.code === "OPDATA_NOT_POPULATED",
  );
}

const useOpDataNotPopulatedHandler = () => {
  const { addToast } = useAppToast();

  return useCallback(
    (error: unknown): boolean => {
      if (!isOpDataNotPopulatedError(error)) return false;
      addToast({
        appearance: "danger",
        message:
          "Operational data is not yet populated for this line and year. Populate it before executing the calculation.",
      });
      return true;
    },
    [addToast],
  );
};

export default useOpDataNotPopulatedHandler;
